import { CategoryRiskNames } from 'common-types';
import { IssueDetails } from '../types/issues-types';
import { User } from '@auth0/auth0-react';

export interface Block {
  type: string;
  text: Text;
  accessory?: Accessory;
  fields?: Field[];
}

export interface Accessory {
  type: string;
  image_url: string;
  alt_text: string;
}

export interface Field {
  type: string;
  text: string;
}

export interface Text {
  type: string;
  text: string;
  emoji?: boolean;
}

export function createSlackMessageBlocks(
  selectedIssue: IssueDetails,
  userComment: {
    user?: User;
    comment: string;
  },
) {
  const { user, comment } = userComment;
  const blocks: Block[] = [
    {
      type: 'header',
      text: {
        type: 'plain_text',
        text: `${selectedIssue.policy.name}`,
        emoji: true,
      },
    },
    {
      type: 'section',
      text: {
        type: 'mrkdwn',
        text: `*<${window.location.origin}/issues?issueId=${selectedIssue.issueId}|${selectedIssue.mainTitle}>*`,
      },
      fields: [
        {
          type: 'mrkdwn',
          text: '*Category*',
        },
        {
          type: 'mrkdwn',
          text: '*App*',
        },
        {
          type: 'plain_text',
          text: selectedIssue.category.name,
        },
        {
          type: 'mrkdwn',
          text: `*<${window.location.origin}/applications?appId=${selectedIssue.app.id}|${selectedIssue.app.name}>*`,
        },
        {
          type: 'mrkdwn',
          text: '*Severity*',
        },
        {
          type: 'mrkdwn',
          text: '*Business Priority*',
        },
        {
          type: 'plain_text',
          text: CategoryRiskNames[selectedIssue.severity],
        },
        {
          type: 'plain_text',
          text: selectedIssue.app.businessPriority.toString(),
        },
      ],
    },
  ];
  if (comment) {
    blocks.push({
      type: 'section',
      text: {
        type: 'mrkdwn',
        text: `*Comment by ${user?.name}*: "${comment}"`,
      },
    });
  }
  if (selectedIssue.learnMore.at(0)) {
    blocks.push({
      type: 'section',
      text: {
        type: 'mrkdwn',
        text: `*<${selectedIssue.learnMore.at(0)}|Learn more>*`,
      },
    });
  }
  return JSON.stringify(blocks);
}
